/**
 * Does a registered webhook's event list take this event?
 *
 * The one copy of the rule. The dispatcher (./webhookDispatch.ts) uses it to
 * decide where a delivery goes; the app's Automations page uses it to tell a
 * person, before they save a "send a webhook" rule, whether any registered
 * address would receive it. Two copies would let the page say "yes" while the
 * dispatcher sends nothing.
 *
 * MUST stay dependency-free — zero imports, no Deno or browser globals — so the
 * Vite app can import it directly (see src/types/deno-npm-specifiers.d.ts).
 *
 * An empty list or '*' takes everything; 'item.*' takes 'item.created'.
 */
export function eventMatches(webhookEvents: readonly string[] | undefined | null, eventType: string): boolean {
  if (!webhookEvents || webhookEvents.length === 0) return true;
  if (webhookEvents.includes('*')) return true;
  if (webhookEvents.includes(eventType)) return true;
  const [entity] = eventType.split('.');
  if (webhookEvents.includes(`${entity}.*`)) return true;
  return false;
}
